import { SmgElement } from '../core/smg-element';
import { html, when, type SafeHtml } from '../core/safe-html';
import { toastStore, TOAST_COLORS, TOAST_ICONS } from '../services/toast-service';

/** Global bildirim — mobilde alt menünün üstünde, masaüstünde altta ortada. */
export class SmgToast extends SmgElement {
  protected override onConnected(): void {
    this.bind(toastStore);
  }

  protected override template(): SafeHtml {
    const toast = toastStore.get();
    return html`${when(toast, () => {
      const t = toast!;
      return html`
        <div style="position:fixed;left:16px;right:16px;bottom:var(--smg-toast-bottom,24px);z-index:40;display:flex;justify-content:center;pointer-events:none">
          <div style="display:flex;align-items:center;gap:9px;padding:12px 16px;background:var(--vx-ink);color:var(--vx-on-ink);border-radius:var(--vx-radius-md);box-shadow:var(--vx-shadow-lg);animation:fadeIn .18s;max-width:460px">
            <i class="${TOAST_ICONS[t.type]}" style="font-size:18px;color:${TOAST_COLORS[t.type]}"></i>
            <span style="font:500 13px var(--vx-font-sans)">${t.message}</span>
          </div>
        </div>`;
    })}`;
  }
}

customElements.define('smg-toast', SmgToast);
